import { baseUrl } from "../const/base-url";
import type { CartItem } from "../state/cart";

export type OrderPayload = {
  table: number;
  persons: number;
  items: Array<{
    name: string;
    size?: string | null;
    count: number;
    price: number;
    taste: string;
    totalPrice: number;
  }>;
};

export function buildOrderPayload(
  table: number,
  persons: number,
  items: CartItem[]
): OrderPayload {
  return {
    table,
    persons,
    items: items.map((i) => ({
      name: i.title,
      size: (i as any).sizeKey ?? null,
      count: i.qty,
      price: Number(i.price),
      taste: i.taste ? i.taste.name : "-",
      totalPrice: Number((i.price * i.qty).toFixed(2)),
    })),
  };
}

export async function sendOrder(payload: OrderPayload) {
  const res = await fetch(`${baseUrl}/api/mail`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(txt || "Order send failed");
  }
  return res.json();
}
